import React from 'react'

import { SelectField } from '@components/forms/SelectField'
import { InputField } from '@components/forms/InputField'
import { SelectSearchField } from '@components/forms/SelectSearchField'
import { UploadFile } from '@features/profile/components/UploadFile'
import { bankAccountTypeOptions } from '@constants/bank'
import { NumberField } from '@components/forms/NumberField'
import { BankAcccountInformationProps } from './interface'

export const BankAccountInformation = React.memo(
  ({
    bankCode,
    bankOptions,
    branchOptions,
    handleBankChange,
    handleBankBranchChange,
  }: BankAcccountInformationProps) => {
    return (
      <div>
        <h2 className='font-mitr text-[24px] ladding-1.5 font-medium text-secondary dark:text-dark-10'>
          ข้อมูลบัญชีธนาคาร
        </h2>
        <p className='text-secondary dark:text-dark-10 text-[14px] font-light mt-[20px] mobile:mt-[10px]'>
          - ชื่อบัญชีจะต้องตรงกับชื่อตามบัตรประชาชนหรือนิติบุคคลเท่านั้น
        </p>
        <p className='text-secondary dark:text-dark-10 text-[14px] font-light'>
          - ในการโอนเงินแต่ละรอบบิล
          ธนาคารอาจมีการหักค่าธรรมเนียมการโอนเงินตามเงื่อนไขของทางธนาคาร
          (ยกเว้นธนาคารกสิกรไทยจะได้รับยกเว้นค่าธรรมเนียม)
        </p>
        <p className='text-secondary dark:text-dark-10 text-[14px] font-light'>
          - หากมีการแก้ไขข้อมูลบัญชีธนาคารและได้รับอนุมัติหลังวันที่ 30 ของเดือน
          ข้อมูลดังกล่าวจะมีผลในรอบบิลถัดไป เช่น แก้ไขข้อมูลวันที่ 15 มกราคม
          ข้อมูลนี้จะถูกนำมาใช้ในรอบโอนเงินเดือนกุมภาพันธ์
        </p>

        <div className='grid grid-cols-3 tablet:grid-cols-2 mobile:grid-cols-1 gap-[20px] mt-[20px]'>
          <SelectSearchField
            name='bankAccount.bankCode'
            label='ธนาคาร'
            placeholder='เลือกธนาคาร'
            options={bankOptions}
            onChange={handleBankChange}
          />
          <SelectSearchField
            name='bankAccount.bankBranchCode'
            label={`สาขา${bankCode ? '' : ' (โปรดเลือกธนาคาร)'}`}
            placeholder='เลือกสาขา'
            options={branchOptions}
            onChange={handleBankBranchChange}
            disabled={!bankCode}
          />
          <InputField
            name='bankAccount.bankProvince'
            label='จังหวัด'
            placeholder='จังหวัด'
            showErrorMsg={false}
            disabled
          />
          <NumberField
            name='bankAccount.accountNumber'
            label='หมายเลขบัญชี'
            placeholder='กรอกไม่เว้นวรรค และไม่ใส่ขีด (-)'
            maxLength={10}
            showErrorMsg={false}
          />
          <InputField
            name='bankAccount.accountName'
            label='ชื่อบัญชี'
            placeholder='กรอกชื่อบัญชี'
            showErrorMsg={false}
          />
          <SelectField
            name='bankAccount.accountType'
            label='ประเภทบัญชี'
            placeholder='เลือกประเภทบัญชี'
            options={bankAccountTypeOptions}
          />

          <UploadFile
            name='bankAccount.bankCoverImgPath'
            label='รูปภาพหน้าบัญชีธนาคาร (ไฟล์ pdf, ไฟล์ภาพ jpg หรือ png)'
            acceptTypes='application/pdf,image/jpeg,image/png'
          />
        </div>
      </div>
    )
  }
)
